<template>
  <div>
    <div v-if="excess === '1'"></div>
    <div v-else>
      <div v-if="isShowTadSim" style="height: calc(100vh - 120px);">
        <div style="height: 100%; display: grid; justify-content: center; align-content: center; font-size: 30px;">
          本阶段仅供联合汽车电子有限公司内部员工和受邀人员使用
        </div>
      </div>
      <div  v-else>
        <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
    <!--头部-->
          <div class="toolbar" style="height: 63px;">
            <div style="width: 12%;display: flex;flex:1;align-items: center;">
              <div style="font-size: 18px;color: #2F374B;min-width: 50px">
                名称：
                <span v-if="nameFlag">
                {{form.appName}}
                </span>
              </div>
              <el-input v-if="!nameFlag" id="name" maxlength="20" v-model="form.appName"  style="width: auto;color: #4D78FF;margin-right: 5px;" size="small " :disabled="nameFlag" clearable></el-input>
              <div v-show="nameFlag" style="font-size: 20px;">
                <i class="el-icon-edit" style="margin: 0 18px;cursor: pointer;color: #4D78FF" @click="nameFlag = !nameFlag"></i>
              </div>
              <el-button v-show="!nameFlag" style="background:#4D78FF;color: white;border-color: #4D78FF" size="small " @click="consoleData">保存</el-button>
            </div>
            <div style="flex:1;position: absolute; right: 20px;">
              <div style=" display: flex">
                <div
                  style="margin-right: 2%;cursor: pointer;display: flex;width: 100px"
                  @click="open">
                <i class="el-icon-s-tools" style="margin: auto;color: #4D78FF;font-size: 24px;"></i>
                  <span style="margin: auto;font-size: 16px">设置</span>
                </div>

                <div style="margin-right: 2%;cursor: pointer;display: flex;width: 100px" class="wrap" @click="save">
                  <i class="el-icon-upload" style="margin: auto;color: #4D78FF;font-size: 26px;"></i>
                  <span style="margin: auto;font-size: 16px">保存</span>
                </div>
                <el-button
                    style="border-radius: 20px;font-size: 14px;color: #4D78FF;border-color: #4D78FF;margin-right: 6%"
                    size="small "
                    @click="openWork"
                    @mouseleave.native="btnFlag = !btnFlag"
                    @mouseenter.native="btnFlag = !btnFlag">{{typeName}}</el-button>
                <div style="display: flex;align-items: center;">
                  <i class="el-icon-close" style="margin: auto;color: #4D78FF;font-size: 26px;cursor: pointer" @click="leave"></i>
                </div>
              </div>
            </div>
          </div>
          <!--body-->
          <div style="padding: 22px 0">
            <el-form-item label="上传开发文件" prop="moduleFile" ref="moduleFile">
              <el-upload
                  style="float: left;margin: 0 5px"
                  accept=".tgz, .zip, .tar.gz, .gz"
                  class="upload-demo"
                  action=""
                  :file-list="fileList"
                  :before-upload="beforeUpload"
                  :http-request="cutomUpload"
                  :show-file-list="false"
                  :disabled="isDisabled"
                  v-model="form.moduleFile"
              >
                <el-button size="small" style="border-radius: 4px;border-color: #4D78FF;color: #4D78FF">选取文件</el-button>
              </el-upload>
              <div style="float: left">
              <span v-show="fileName === ''" style="color:#999999;font-size: 14px;margin: 0 5px">未选择文件</span>
              <span v-show="fileName !== null" style="color:#999999;font-size: 14px;margin: 0 5px">{{fileName}}</span>
              <span v-show="fileName !== ''" style="color: #4D78FF;font-size: 14px;margin: 0 5px" @click="uploadDownload()">
                已上传的文件下载
              </span>
              </div>
              <el-progress style="width:246px" v-if="showProgress" :percentage="percentage"></el-progress>
            </el-form-item>
            <el-form-item label="调用周期" prop="invokePeriod">
              <el-input oninput="value=value.replace(/[^\d]/g,'')" maxlength=20 v-model.number="form.invokePeriod" :disabled="isDisabled" style="width: 556px !important;" size="small" placeholder="请输入调用周期">
                <template slot="append">ms</template>
              </el-input>
              <el-popover
                  placement="top"
                  title=""
                  width="160"
                  trigger="hover"
                  content="APP应用Step方法被调用的周期，单位毫秒">
                <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="预期执行时长" prop="expectExectime">
              <el-input  oninput="value=value.replace(/[^\d]/g,'')" maxlength=20 v-model.number="form.expectExectime" :disabled="isDisabled" style="width: 556px !important;" size="small" placeholder="请输入预期执行时长">
                <template slot="append">ms</template>
              </el-input>
              <el-popover
                  placement="top"
                  title=""
                  width="160"
                  trigger="hover"
                  content="算法Step方法预期的执行时长，不应大于该算法的调用周期。（仿真系统为了保证场景的可复现性，无论算法每次实际运行时长为多少，对于该算法发出的消息而言，保证在算法预期执行时长结束之前不会被其他算法所见；而在预期结束时长结束之后会立即被其他算法可见）">
                <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="仿真速率控制" prop="playControlRate">
              <el-input  oninput="value=value.replace(/[^\d]/g,'')" maxlength=4 v-model.number="form.playControlRate"  :disabled="isDisabled" style="width: 526px !important;" size="small" placeholder="请输入仿真速率控制">
                <template slot="append">%</template>
              </el-input>
              <el-popover
                  placement="top"
                  title=""
                  width="160"
                  trigger="hover"
                  content="100%为原始仿真速率，百分比值越大，速度越慢；比值越小，速度越快。如设置为10%则为仿真加速10倍。受限于实际分配云端资源、仿真的相关配置。例如算法调度模式（同步、异步）等，实际加速并非和设定预期完全一致 ">
                <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="接入模式" prop="accessMode">
              <el-radio-group v-model="form.accessMode" :disabled="isDisabled">
                <el-radio :label="0">可执行文件</el-radio>
                <el-radio :label="1">动态链接库</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="form.accessMode === 0 ? '可执行文件路径': '动态链接库路径'" prop="mainPath">
              <el-input v-model="form.mainPath" style="width: 556px !important;" :disabled="isDisabled" type="text" size="small" :placeholder="form.accessMode === 0 ? '请输入在文件夹中的可执行文件路径：如bin/bin.dll': '请输入在文件夹中的动态链接库路径：如bin/bin.dll'"></el-input>
              <el-popover
                  placement="top"
                  title=""
                  width="160"
                  trigger="hover"
                  content="对应“可执行文件”接入模式。填写可执行文件在用户解压算法包后的相对路径。字符串格式。例如：planning/libsim_planning.so">
                <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="依赖路径" prop="dependentPath">
              <el-input v-model="form.dependentPath" style="width: 556px !important;" :disabled="isDisabled" type="textarea" size="small" placeholder="请输入依赖路径可','分割支持多个"></el-input>
              <el-popover
                  placement="top"
                  title=""
                  width="160"
                  trigger="hover"
                  content="自动启动模块时模块程序的依赖库搜索路径，应填写解压算法包后的相对路径，路径为以“,”分隔的字符串，例如：./bin.dll">
                <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item :label="'可执行文件参数'">
              <el-input v-model="form.binArgs" style="width: 556px !important;" :disabled="isDisabled" type="textarea" size="small" placeholder="请输入可执行文件参数,可','分割支持多个" ></el-input>
                <el-popover
                  placement="top"
                  title=""
                  width="160"
                  trigger="hover"
                  content="对应“可执行文件”接入模式，所填写字段与所执行的算法脚本一致。数组格式：例如：['--app_name', 'Traffic', '--ip_addr_port', '']。以py脚本为例，Python执行命令一般使用 'python xxx.py --key value'，那么该栏填写python的命令行参数，'['xxx.py', '--key', 'value']'">
                <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="初始化参数">
              <el-input v-model.trim="form.initargs" style="width: 556px !important;" :disabled="isDisabled" maxlength="1000" type="textarea" size="small" placeholder="请输入初始化参数,可';'分割支持多个"></el-input>
            </el-form-item>
            <el-form-item label="执行超时时间">
              <el-input v-model.number="form.execTimeout" style="width: 556px !important;" :disabled="isDisabled" size="small" placeholder="请输入执行超时时间">
                <template slot="append">ms</template>
              </el-input>
              <el-popover
                  placement="top"
                  title=""
                  width="160"
                  trigger="hover"
                  content="算法执行仿真定义的接口函数时的最大超时时间。">
                <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <el-form-item label="单步超时时间">
              <el-input v-model.number="form.onestepTimeout" style="width: 556px !important;" :disabled="isDisabled" size="small" placeholder="请输入单步超时时间">
                <template slot="append">ms</template>
              </el-input>
              <el-popover
                  placement="top"
                  title=""
                  width="160"
                  trigger="hover"
                  content="算法Step方法的最大超时时间。">
                <i class="el-icon-question" style="font-size: 18px;margin-left: 10px;cursor: pointer;color: #4D78FF" slot="reference"></i>
              </el-popover>
            </el-form-item>
            <div style="height: 1px; width: 100%;background: #c0c4cc;margin: 20px 0;"></div>
            <div>
              <el-form-item label="算法配置" prop="moduleIds">
                <Algorithm ref="Algorithm" :list="moduleDataList" :dataList="moduleDataList" :moduleDataValue="moduleDataValue" @handleChange="handleChange" :isDisabled="isDisabled"></Algorithm>
                <div>
                  <span class="icon-tittle" @click="governModules()">管理算法</span>
                  <icon class="el-icon-refresh refresh-icon" @click="refreshModules()"></icon>
                </div>
              </el-form-item>
            </div>
            <el-form-item label="仿真场景" prop="sceneIds">
              <el-cascader
                v-model="sceneSetTreeValue"
                @change="sceneSetTreeChange"
                :options="sceneSetTree"
                :props="sceneSetTreeProps"
                style="width: 556px !important"
                collapse-tags
                clearable
                :disabled="isDisabled" >
              </el-cascader>
              <div>
                <span class="icon-tittle" @click="governSceneSet()">管理场景集</span>
                <icon class="el-icon-refresh refresh-icon" @click="refreshSceneSet()"></icon>
              </div>
            </el-form-item>
            <el-form-item label="指标组" prop="indicatorGroupId">
              <el-select v-model="form.indicatorGroupId" placeholder="请选择" :disabled="isDisabled" >
                <el-option
                  v-for="item in indicatorGroupList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                  >
                </el-option>
              </el-select>
              <div style="display: flex;">
                <div style="padding-right: 20px">
                  <span class="icon-tittle" @click="getIndicatorGroupDetail()">查看指标组详情</span>
                </div>
                <div>
                  <span class="icon-tittle" @click="governIndicatorGroup()">管理指标组</span>
                  <icon class="el-icon-refresh refresh-icon" @click="refreshIndicatorGroup()"></icon>
                </div>
              </div>
            </el-form-item>
          </div>
          <!--弹窗-->
          <el-dialog
              @close="cancelCatalogueUpdate"
              title="设置"
              :visible.sync="centerDialogVisible"
              :modal-append-to-body="false"
              width="50%"
              center>
              <el-form :model="catalogueProperties" >
              <el-row>
                <el-col style="text-align: center">
                  <el-form-item label="应用介绍：" style="display: inline-flex;">
                    <el-input
                        resize="none"
                        type="textarea"
                        :rows="3"
                        placeholder="请输入内容"
                        style="width: 246px"
                        maxlength="1000"
                        v-model="catalogueProperties.newDescribes">
                      </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col style="text-align: center">
                  <el-form-item label="应用图标：" style="display: inline-flex;padding-left: 260px;white-space:nowrap;">
                    <div style="display:flex;width: 506px">
                      <el-upload
                        :limit="1"
                        :before-upload="logoUrlBeforeUpload"
                        :http-request="logoUrlCutomUpload"
                        list-type="picture-card"
                        action=""
                        :file-list="logFileList"
                        ref="logFileList"
                        :on-exceed="handleExceed"
                        >
                          <i slot="default" class="el-icon-plus"></i>
                          <div slot="file" slot-scope="{file}">
                            <img class="el-upload-list__item-thumbnail" :src="catalogueProperties.newLogoUrl">
                            <span class="el-upload-list__item-actions">
                              <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                <i class="el-icon-zoom-in"></i>
                              </span>
                              <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                                <i class="el-icon-delete"></i>
                              </span>
                            </span>
                          </div>
                      </el-upload>
                      <el-dialog :visible.sync="uploadDialogVisible">
                        <img width="100%" :src="dialogImageUrl">
                      </el-dialog>
                    </div>
                    <div style="font-size: 12px;text-align: left;line-height: 20px;">
                      <span>图片格式：png、jpg、jpeg，且不超过500kb，</span><br>
                      <span>最多上传一张图片,建议尺寸：230 X 150 px</span>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
                <el-row>
                  <el-col style="text-align: center">
                    <el-form-item label="应用分类：" style="display: inline-flex;">
                      <el-select v-model="catalogueProperties.appType" clearable placeholder="未分类" style="width: 246px">
                        <el-option
                            v-for="item in options"
                            :key="item.tagId"
                            :label="item.tagName"
                            :value="item.tagName">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              <el-row style="padding-top: 41px">
                <el-col style="text-align: center">
                  <el-button type="primary" @click="catalogueUpdate()" class="confirmButton" round>确 定</el-button>
                  <el-button @click="centerDialogVisible = false" class="cancelButton" round>取 消</el-button>
                </el-col>
              </el-row>
            </el-form>
          </el-dialog>
          <el-drawer
              title=""
              size="85%"
              :visible.sync="drawer"
              :with-header="false">
            <div style="width: 100% height: 100%;">
              <div style="width: 100%; height: 100%;">
                <div style="margin: 0px 0px 40px 0px; font-weight: bold; text-align: center; font-size: 18px;">应用状态</div>
                <div style="width: 100%; height: 120px;">
                  <el-col :span="5" style="text-align: center;">
                    <img :src="img1" alt="" style="width: 117px; height: 127px;">
                  </el-col>
                  <el-col :span="5" style="text-align: center;">
                    <img :src="img2" alt="" style="width: 117px; height: 127px;">
                  </el-col>
                  <el-col :span="5" style="text-align: center;">
                    <img :src="img3" alt="" style="width: 117px; height: 127px;">
                  </el-col>
                  <el-col :span="5" style="text-align: center;">
                    <img :src="img4" alt="" style=";width: 117px; height: 127px;">
                  </el-col>
                  <el-col :span="4" style="text-align: center;">
                    <img :src="img5" alt="" style="width: 117px; height: 127px;">
                  </el-col>
                </div>
                <div style="width: 100%; height: 40px;margin: 20px 0px 10px 0px;">
                  <el-col :span="5" :offset="3" style="height: 100%;display: flex;align-items: center;">
                    <div :class="appStatus.appStage > 0 ? 'onOver' : 'onWork'" style="border-radius: 50%;width: 20px;height: 20px; margin-left: -45px;"></div>
                    <div :class="appStatus.appStage > 0 ? 'onWork_line' : 'line'" style="width: calc(100% - 30px)"></div>
                  </el-col>
                  <el-col :span="5" style="height: 100%;display: flex;align-items: center;">
                    <div :class="[appStatus.appStage < 1 ? 'onInit' : '', appStatus.appStage > 1 ? 'onOver' : '', appStatus.appStage == 1 ? 'onWork' : '']"  style="border-radius: 50%;width: 20px;height: 20px; margin-left: -45px;"></div>
                    <div :class="appStatus.appStage > 1 ? 'onWork_line' : 'line'" style="width: calc(100% - 30px)"></div>
                  </el-col>
                  <el-col :span="5" style="height: 100%;display: flex;align-items: center;">
                    <div :class="[appStatus.appStage < 2 ? 'onInit' : '', appStatus.appStage > 2 ? 'onOver' : '', appStatus.appStage == 2 ? 'onWork' : '']"  style="border-radius: 50%;width: 20px;height: 20px; margin-left: -45px;"></div>
                    <div :class="appStatus.appStage > 2 ? 'onWork_line' : 'line'" style="width: calc(100% - 30px)"></div>
                  </el-col>
                  <el-col :span="5" style="height: 100%;display: flex;align-items: center;">
                    <div :class="[appStatus.appStage < 3 ? 'onInit' : '', appStatus.appStage > 3 ? 'onOver' : '', appStatus.appStage == 3 ? 'onWork' : '']"  style="border-radius: 50%;width: 20px;height: 20px; margin-left: -45px;"></div>
                    <div :class="appStatus.appStage > 3 ? 'onWork_line' : 'line'" style="width: calc(100% - 60px)"></div>
                  </el-col>
                  <el-col :span="1" style="height: 100%;display: flex;align-items: center;">
                    <div :class="[appStatus.appStage < 4 ? 'onInit' : '', appStatus.appStage > 4 ? 'onOver' : '', appStatus.appStage == 4 ? 'onWork' : '']" style="border-radius: 50%;width: 20px;height: 20px; margin-left: -76px;"></div>
                  </el-col>
                </div>
                <div style="height: 30px;width: 100%;font-size: 12px;text-align: center;">
                  <el-col :span="5" style="height: 100%; text-align: center;">
                    <div v-if="appStatus.stageStatus === 0" class="status">开发中</div>
                    <div v-if="appStatus.stageStatus > 0" class="status">开发完成</div>
                  </el-col>
                  <el-col :span="5" style="height: 100%; text-align: center;">
                    <div v-if="appStatus.appStage < 1" class="waitStatus">等待中</div>
                    <div v-if="appStatus.stageStatus === 10" class="waitStatus">等待测试</div>
                    <div v-if="appStatus.stageStatus === 11" class="status">测试中</div>
                    <div v-if="appStatus.stageStatus === 12" class="status">运行失败</div>
                    <div v-if="appStatus.stageStatus >= 13" class="status">测试完成</div>
                  </el-col>
                  <el-col :span="5" style="height: 100%; text-align: center;">
                    <div v-if="appStatus.appStage < 2" class="waitStatus">等待中</div>
                    <div v-if="appStatus.stageStatus === 20" class="waitStatus">等待测试</div>
                    <div v-if="appStatus.stageStatus ===21" class="status">测试中</div>
                    <div v-if="appStatus.stageStatus >= 22" class="status">测试完成</div>
                  </el-col>
                  <el-col :span="5" style="height: 100%; text-align: center;">
                    <div v-if="appStatus.appStage < 3" class="waitStatus">等待中</div>
                    <div v-if="appStatus.stageStatus === 30" class="waitStatus">等待测试</div>
                    <div v-if="appStatus.stageStatus === 31"  class="status">测试中</div>
                    <div v-if="appStatus.stageStatus >= 32" class="status">测试完成</div>
                  </el-col>
                  <el-col :span="4" style="height: 100%; text-align: center;">
                    <div v-if="appStatus.appStage < 4" class="waitStatus">等待中</div>
                    <div v-if="appStatus.stageStatus === 40" class="waitStatus">等待发布</div>
                    <div v-if="appStatus.stageStatus > 40" class="status">发布完成</div>
                  </el-col>
                </div>
                <div style="height: 100%; margin: 20px 0px;">
                  <div style="width: 100%; height: 100%; display: flex; overflow: auto;">
                    <el-col v-if="appStatusInfo&&appStatusInfo.sil" :span="5" :offset="6">
                      <div v-for="(item, index) in appStatusInfo.sil.node" :key="'sil' + index" style="color: #2F374B;font-size: 14px;letter-spacing:1px;margin-bottom: 5%;margin-left: 15%">
                        <div style="display: inline-block;">
                          <div style="display: flex;align-items: center">
                            <i class="el-icon-time" style="font-size: 20px;padding-right: 5px"></i>
                            {{item.message}}
                            <span v-if="index === 2 && (appStatus.stageStatus === 13 || appStatus.stageStatus >= 20)" style="margin-left: 5px; font-size: 12px;height: 22px;width: 46px;line-height: 22px;border: 1px solid #09D589;border-radius: 13px;color: #09D589;text-align: center;letter-spacing:1px">通过</span>
                            <span v-if="index === 2 && (appStatus.stageStatus === 12)" style="margin-left: 5px; font-size: 12px;height: 22px;width: 46px;line-height: 22px;border: 1px solid #FF0000;border-radius: 13px;color: #FF0000;text-align: center;letter-spacing:1px">不通过</span>
                          </div>
                        </div>
                        <div style="font-size: 12px;color: #999999;padding-top: 10px;padding-bottom: 11px">{{item.time}}</div>
                        <!-- <div v-if="item.memo" style="font-size: 12px;color: #999999;"><el-button type="text" @click="showRefuseMessage(item.memo)">不通过原因</el-button></div>-->
                        <div v-if="item.memo" style="font-size: 12px;color: #999999;">{{item.memo}}</div>
                      </div>
                      <div style="height: 120px; overflow-y: auto;">
                        <div v-if="appStatusInfo.sil.detailUrl" :key="item" style="margin-left: 15%;font-size: 14px;margin-bottom: 15px;">
                          <a :href="appStatusInfo.sil.detailUrl" target="_blank" style="color: #4D78FF">查看报告></a>
                        </div>
                        <div v-if="appStatusInfo.sil.replayUrl" :key="item" style="margin-left: 15%;font-size: 14px;margin-bottom: 15px;">
                          <div v-for="(replayUrlItem, replayUrlIndex) in appStatusInfo.sil.replayUrl.split(',')"  :key="replayUrlIndex">
                            <a :href="replayUrlItem" target="_blank" style="color: #4D78FF">{{appStatus.stageStatus === 11 ? '查看测试动态>' : '查看回放>' }}</a>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col v-if="appStatusInfo&&appStatusInfo.hil" :span="5">
                      <div v-for="(item, index) in appStatusInfo.hil.node" :key="'hil' + index" style="color: #2F374B;font-size: 14px;letter-spacing:1px;margin-bottom: 5%;margin-left: 15%">
                        <div style="">
                          <i class="el-icon-time" style="font-size: 20px;"></i>
                          {{item.message}}
                          <span v-if=" index === 2 && (appStatus.stageStatus === 22 || appStatus.stageStatus >= 30)" style="font-size: 12px;height: 22px;width: 46px;line-height: 22px;border: 1px solid #09D589;border-radius: 13px;color: #09D589;text-align: center;letter-spacing:1px">通过</span>
                          <span v-if=" index === 2 && (appStatus.stageStatus === 23)" style="font-size: 12px;height: 22px;width: 46px;line-height: 22px;border: 1px solid #FF0000;border-radius: 13px;color: #FF0000;text-align: center;letter-spacing:1px">不通过</span>
                        </div>
                        <div style="font-size: 12px;color: #999999;padding-top: 10px;padding-bottom: 11px">{{item.time}}</div>
                        <div v-if="item.memo" style="font-size: 12px;color: #999999;"><el-button type="text" @click="showRefuseMessage(item.memo)">不通过原因</el-button></div>
                        <!-- <div v-if="item.memo" style="font-size: 12px;color: #999999;">{{item.memo}}</div> -->
                      </div>
                    </el-col>
                    <el-col v-if="appStatusInfo&&appStatusInfo.vehicle" :span="5">
                      <div v-for="(item, index) in appStatusInfo.vehicle.node" :key="'vehicle' + index" style="color: #2F374B;font-size: 14px;letter-spacing:1px;margin-bottom: 5%;margin-left: 15%">
                        <div style="">
                          <i class="el-icon-time" style="font-size: 20px;"></i>
                          {{item.message}}
                          <span v-if=" index === 2 && (appStatus.stageStatus === 32 || appStatus.stageStatus >= 40)" style="font-size: 12px;height: 22px;width: 46px;line-height: 22px;border: 1px solid #09D589;border-radius: 13px;color: #09D589;text-align: center;letter-spacing:1px">通过</span>
                          <span v-if=" index === 2 && (appStatus.stageStatus === 33)" style="font-size: 12px;height: 22px;width: 46px;line-height: 22px;border: 1px solid #FF0000;border-radius: 13px;color: #FF0000;text-align: center;letter-spacing:1px">不通过</span>
                        </div>
                        <div style="font-size: 12px;color: #999999;padding-top: 10px;padding-bottom: 11px">{{item.time}}</div>
                        <!-- <div v-if="item.memo" style="font-size: 12px;color: #999999;">{{item.memo}}</div> -->
                        <div v-if="item.memo" style="font-size: 12px;color: #999999;"><el-button type="text" @click="showRefuseMessage(item.memo)">不通过原因</el-button></div>
                      </div>
                    </el-col>
                    <el-col v-if="appStatusInfo&&appStatusInfo.release" :span="3">
                      <div v-for="(item, index) in appStatusInfo.release.node" :key="'release' + index" style="color: #2F374B;font-size: 14px;letter-spacing:1px;margin-bottom: 5%;margin-left: 8%">
                        <div style="">
                          <i class="el-icon-time" style="font-size: 20px;"></i>
                          {{item.message}}
                          <span v-if=" index === 1 && (appStatus.stageStatus === 41)" style="font-size: 12px;height: 22px;width: 46px;line-height: 22px;border: 1px solid #09D589;border-radius: 13px;color: #09D589;text-align: center;letter-spacing:1px">通过</span>
                          <span v-if=" index === 1 && (appStatus.stageStatus === 42)" style="font-size: 12px;height: 22px;width: 46px;line-height: 22px;border: 1px solid #FF0000;border-radius: 13px;color: #FF0000;text-align: center;letter-spacing:1px">不通过</span>
                        </div>
                        <div style="font-size: 12px;color: #999999;padding-top: 10px;padding-bottom: 11px">{{item.time}}</div>
                        <!-- <div v-if="item.memo" style="font-size: 12px;color: #999999;">{{item.memo}}</div> -->
                        <div v-if="item.memo" style="font-size: 12px;color: #999999;"><el-button type="text" @click="showRefuseMessage(item.memo)">不通过原因</el-button></div>
                      </div>
                    </el-col>
                  </div>
                </div>
                <div style="display: flex;align-items: center;justify-content:center" >
                  <el-button v-if="buttonName" size="medium" round style="background-color:#4D78FF;border-color: #4D78FF;color: white;" @click="clickButton">{{buttonName}}</el-button>
                  <el-button v-if="buttonBack" size="medium" round style="background-color:#4D78FF;border-color: #4D78FF;color: white;" @click="clickBackButton">{{buttonBack}}</el-button>
                  <el-button v-if="appStatus.stageStatus === 32" size="medium" round style="background-color:#4D78FF;border-color: #4D78FF;color: white;" @click="Submit">提交发布</el-button>
                  <el-button v-if="(appStatus.stageStatus === 12 || appStatus.stageStatus === 14 || appStatus.stageStatus === 23 || appStatus.stageStatus === 33 || appStatus.stageStatus === 42)" size="medium" round style="background-color:#FF0000;border-color: #FF0000;color: white;" @click="backDevelop" >重新开发</el-button>
                  <el-button v-if="(appStatus.stageStatus === 42)" size="medium" round style="background-color:#FF0000;border-color: #FF0000;color: white;" @click="reSubmit" >重新发布</el-button>
                  <el-button v-if="appStatus.stageStatus === 40" size="medium" round style="background-color:#4D78FF;border-color: #4D78FF;color: white;" @click="releaseApp">取消</el-button>
                </div>
                <el-dialog
                    title="发布应用"
                    :visible.sync="scenesPublishDialogVisible"
                    :modal-append-to-body="false"
                    :append-to-body="true"
                    width="20%"
                    center>
                  <div>发布前需要您完善个人信息中的手机号和邮箱。信息只需完善一次。请前往个人中心进行补充。</div>
                  <span slot="footer" class="dialog-footer">
                    <el-button size="small " type="primary" @click="accountViewClick()" style="background-color: #4D78FF;border-radius: 20px;padding: 8px 25px">前 往</el-button>
                  </span>
                </el-dialog>
                <el-dialog
                    :before-close="cancelCatalogueSettingUpdate"
                    title="设置"
                    :visible.sync="publishingSettings"
                    modal-append-to-body="true"
                    append-to-body
                    width="900px"
                    center>
                    <el-form :model="catalogueProperties" :rules="rules1" ref="form" label-position="left">
                    <el-row>
                      <el-col style="text-align: center">
                        <el-form-item label="应用名称：" style="display: inline-flex;">
                          <el-input
                              type="text"
                              placeholder="请输入内容"
                              style="width: 246px"
                              v-model="form.appName"
                              disabled>
                            </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col style="text-align: center">
                        <el-form-item label="应用介绍：" prop="newDescribes" style="display: inline-flex;">
                          <el-input
                              resize="none"
                              type="textarea"
                              :rows="3"
                              placeholder="请输入内容"
                              style="width: 246px"
                              v-model="catalogueProperties.newDescribes">
                            </el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col style="text-align: center">
                        <el-form-item label="应用图标：" prop="newLogoUrl" style="display: inline-flex;padding-left: 260px;white-space:nowrap;">
                          <div style="display:flex;width: 506px">
                            <el-upload
                              :limit="1"
                              :before-upload="logoUrlBeforeUpload"
                              :http-request="logoUrlCutomUpload"
                              list-type="picture-card"
                              action=""
                              :file-list="logFileList"
                              ref="logFileList"
                              :on-exceed="handleExceed"
                              >
                                <i slot="default" class="el-icon-plus"></i>
                                <div slot="file" slot-scope="{file}">
                                  <img class="el-upload-list__item-thumbnail" :src="catalogueProperties.newLogoUrl">
                                  <span class="el-upload-list__item-actions">
                                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                      <i class="el-icon-zoom-in"></i>
                                    </span>
                                    <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                                      <i class="el-icon-delete"></i>
                                    </span>
                                  </span>
                                </div>
                            </el-upload>
                            <el-dialog :visible.sync="uploadDialogVisible">
                              <img width="100%" :src="dialogImageUrl">
                            </el-dialog>
                          </div>
                          <div style="font-size: 12px;text-align: left;line-height: 20px;">
                            <span>图片格式：png、jpg、jpeg，且不超过500kb，</span><br>
                            <span>最多上传一张图片,建议尺寸：230 X 150 px</span>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                      <el-row>
                        <el-col style="text-align: center">
                          <el-form-item label="应用分类：" style="display: inline-flex;">
                            <el-select v-model="catalogueProperties.appType" clearable placeholder="未分类" style="width: 246px">
                              <el-option
                                  v-for="item in options"
                                  :key="item.tagId"
                                  :label="item.tagName"
                                  :value="item.tagName">
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    <el-row style="padding-top: 41px">
                      <el-col style="text-align: center">
                        <el-button type="primary" @click="publishsettingUpdate('form')" class="confirmButton" round>确 定</el-button>
                        <el-button @click="publishingSettings = false" class="cancelButton" round>取 消</el-button>
                      </el-col>
                    </el-row>
                  </el-form>
                </el-dialog>
                <el-dialog
                    title="发布此应用"
                    :visible.sync="scenesCodePublishDialogVisible"
                    :modal-append-to-body="false"
                    :append-to-body="true"
                    :before-close="scenesCodePublishDialogClose"
                    width="20%"
                    center>
                  <div>发布协议发送到您的邮箱，同时还包含了本次发布的动态验证码，请查收邮件阅读发布协议并填写动态验证码。</div>
                  <div style="margin-top: 20px;">发布动态验证码：<el-input v-model="scenesPublishCode" placeholder="请输入动态验证码" style="width:160px;"></el-input></div>
                  <div style="margin-top: 20px;">输入验证码代表您接受本次的发布协议。</div>
                  <span slot="footer" class="dialog-footer">
                    <el-button size="small " type="primary" @click="secnesPublishCodeClick()" style="background-color: #4D78FF;border-radius: 20px;padding: 8px 25px">提交发布</el-button>
                  </span>
                </el-dialog>
                <el-dialog
                  title="不通过原因"
                  :visible.sync="showRefuseMessageVisible"
                  :modal-append-to-body="false"
                  :append-to-body="true"
                  width="20%"
                  custom-class="refuse-class"
                  center>
                  <el-form :model="noPassReasonForm">
                    <el-form-item label="原因">
                      <el-input v-model="noPassReasonForm.noPassReason" type="textarea" autocomplete="off" disabled="true"/>
                    </el-form-item>
                  </el-form>
                </el-dialog>
              </div>
            </div>
          </el-drawer>
          <el-dialog
            @close="cancelCatalogueUpdate"
            title="指标组详情"
            :visible.sync="indicatorGroupDetailVisible"
            :modal-append-to-body="false"
            width="80%"
            center>
            <el-table
              :data="indicatorsList"
              :header-cell-style="{'text-align':'center','background':'#EEF7FF'}"
              :cell-style="{'text-align':'center'}"
              border
              stripe
              style="width: 100%;">
            <el-table-column
              prop="id"
              label="ID">
            </el-table-column>
            <el-table-column
              prop="name"
              label="指标名称">
            </el-table-column>
            <el-table-column
              prop="categoryDesc"
              label="分类">
            </el-table-column>
            <el-table-column
              prop="definition"
              label="定义">
            </el-table-column>
            <el-table-column
              prop="calculationMethod"
              label="计算方式">
            </el-table-column>
            <el-table-column
                label="默认阈值">
              <template slot-scope="scope">
                {{ scope.row.threshold.volume ? scope.row.threshold.volume : '-'}}
                {{ scope.row.threshold.unit ? scope.row.threshold.unit : '-'}}
              </template>
            </el-table-column>
            <el-table-column
                label="默认通过条件">
              <template slot-scope="scope">
                {{ scope.row.passCondition.desc ? scope.row.passCondition.desc : ''}}
                {{ scope.row.passCondition.volume ? scope.row.passCondition.volume : ''}}
                {{ scope.row.passCondition.unit ? scope.row.passCondition.unit : ''}}
              </template>
            </el-table-column>
            <el-table-column
                label="作为场景结束条件">
                <template slot-scope="scope">
                  {{ scope.row.finishCondition.volume == '0' ? '否' : '是'}}
                </template>
            </el-table-column>
            <el-table-column
              prop="createBy.name"
              label="创建者">
            </el-table-column>
          </el-table>
          </el-dialog>
        </el-form>
      </div>
    </div>
  </div>

</template>

<script>
import { addorupdata } from '@/api/modules/professionalLevel'
import { getSceneSetList, getSceneList, getAppTestInfo, backAppTest, setAppTestInfo, cancelAppTest, getDetails, selectCountApp, getSceneSetTree, getModuleList, getIndicatorGroupList, getIndicatorGroupDetail, sendCodeByEmail, verifyCodeByEmail, releaseApp, backDevelopTadsim, releaseAppAgain } from '@/api/modules/major'
import COS from 'cos-js-sdk-v5'
import { getUploadKey } from '@/api/modules/api'
import { mapGetters } from 'vuex'
import car_done from '@/assets/img/editor/done/car_done.png'
import hil_done from '@/assets/img/editor/done/hil_done.png'
import release_done from '@/assets/img/editor/done/release_done.png'
import sil_done from '@/assets/img/editor/done/sil_done.png'
import work_done from '@/assets/img/editor/done/work_done.png'
import car_wait from '@/assets/img/editor/wait/car_wait.png'
import hil_wait from '@/assets/img/editor/wait/hil_wait.png'
import release_wait from '@/assets/img/editor/wait/release_wait.png'
import sil_wait from '@/assets/img/editor/wait/sil_wait.png'
import car_work from '@/assets/img/editor/work/car_work.png'
import hil_work from '@/assets/img/editor/work/hil_work.png'
// import release_work from '@/assets/img/editor/work/release_work.png'
import sil_work from '@/assets/img/editor/work/sil_work.png'
import work_work from '@/assets/img/editor/work/work_work.png'
import { getLabel } from '@/api/modules/forum'
import Algorithm from '@/components/algorithm'
import { isShowTadSim } from '@/api/modules/professionalLevel'
export default {
  components: {
    Algorithm
  },
  props: {
  },
  data() {
    return {
      host: location.hostname === 'localhost' ? 'https://usp-test.uaes.com' : '',
      scenesCodePublishDialogVisible: false,
      publishingSettings: false,
      options: [],
      appId: this.$route.query.id,
      showProgress: false,
      percentage: 0,
      scenesPublishCode: '',
      form: {
        id: null,
        moduleId: '',
        moduleConfigId: '',
        catalogueId: this.$route.query.catalogueId,
        appName: '',
        appDesc: '',
        appType: '',
        sceneSetid: '',
        sceneId: '',
        invokePeriod: 1000,
        expectExectime: 10,
        accessMode: 1,
        mainPath: './bin/libapp_algorithm.so',
        dependentPath: './bin',
        binArgs: '',
        initargs: '',
        execTimeout: '3000',
        onestepTimeout: '3000',
        moduleKey: '',
        moduleFile: '',
        appStage: 0,
        playControlRate: 100,
        moduleIds: '',
        indicatorGroupId: '',
        sceneIds: '',
        forceCreate: false
      },
      rules: {
        invokePeriod: [
          { required: true, message: '请输入调用周期', trigger: 'blur' }
        ],
        expectExectime: [
          { required: true, message: '请输入预期执行时长', trigger: 'blur' }
        ],
        moduleFile: [
          { required: true, message: '请上传文件', trigger: 'change' }
        ],
        appName: [
          { required: true, message: '请输入算法名称', trigger: 'blur' },
          { max: 20, message: '长度在20以内的字符', trigger: 'blur' }
        ],
        mainPath: [
          { required: true, message: '请输入可执行文件路径', trigger: 'blur' },
          { max: 1000, message: '长度在1000以内的字符', trigger: 'blur' }
        ],
        dependentPath: [
          { required: true, message: '请输入依赖路径', trigger: 'blur' },
          { max: 1000, message: '长度在1000以内的字符', trigger: 'blur' }
        ],
        sceneId: [
          { required: true, message: '请选择仿真场景', trigger: 'blur' }
        ],
        sceneSetid: [
          { required: true, message: '请选择仿真场景', trigger: 'blur' }
        ],
        accessMode: [
          { required: true, message: '请选择接入模式', trigger: 'blur' }
        ],
        indicatorGroupId: [
          { required: true, message: '请选择指标组', trigger: 'blur' }
        ],
        sceneIds: [
          { required: true, message: '请选择仿真场景', trigger: 'blur' }
        ],
        moduleIds: [
          { required: true, message: '请选择算法配置', trigger: 'blur' }
        ]
      },
      command: null,
      // name: '',
      textarea: '',
      centerDialogVisible: false,
      dialogVisible: false,
      fileListAttr: [],
      testFlag: false,
      nameFlag: true,
      btnFlag: false,
      drawer: false,
      input: '',
      radio: '1',
      radio1: '1',
      radio2: '1',
      fileList: '',
      addResource: null,
      fileName: '',
      fileUrlName: '',
      sceneSetList: [],
      sceneList: [],
      appStatus: { appStage: -1, stageStatus: 0 },
      appStatusInfo: null,
      catalogueProperties: {
        appType: '',
        id: '',
        newDescribes: '',
        newLogoKey: '',
        newLogoUrl: ''
      },
      uploadDialogVisible: false,
      dialogImageUrl: '',
      logFileList: [],
      isDisabled: false,
      sceneSetTree: [],
      moduleDataList: [],
      moduleDataValue: [],
      sceneSetTreeValue: [],
      indicatorGroupList: [],
      sceneSetTreeProps: {
        multiple: true,
        value: 'id',
        label: 'label',
        children: 'scenes'
      },
      indicatorGroupDetail: {},
      indicatorsList: [],
      indicatorGroupDetailVisible: false,
      showRefuseMessageVisible: false,
      noPassReasonForm: {
        noPassReason: ''
      },
      scenesPublishDialogVisible: false,
      rules1: {
        newDescribes: [
          { required: true, message: '请填写应用介绍', trigger: 'blur' }
        ],
        newLogoUrl: [
          { required: true, message: '请上传应用图标', trigger: 'blur' }
        ]
      },
      releaseAgain: false,
      isShowTadSim: false,
      excess: '1',
      results: null,
      isDrawer: false
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userAuth/getUsersCurrentInfo'
    }),
    showPage() {
      return !!this.userInfo || this.$route.meta.noAuth
    },
    typeName() {
      if (this.form.appStage === 1) {
        return 'SIL测试'
      }
      if (this.form.appStage === 2) {
        return 'HIL测试'
      }
      if (this.form.appStage === 3) {
        return '车辆测试'
      }
      if (this.form.appStage === 4) {
        return '发布'
      }
      else {
        return '测试与发布'
      }
    },
    img1() {
      if (this.appStatus && Number(this.appStatus.appStage) === 0) {
        return work_work
      }
      return work_done
    },
    img2() {
      if (this.appStatus && Number(this.appStatus.appStage) === 1) {
        return sil_work
      }
      if (this.appStatus && Number(this.appStatus.appStage) > 1) {
        return sil_done
      }
      return sil_wait
    },
    img3() {
      if (this.appStatus && Number(this.appStatus.appStage) === 2) {
        return hil_work
      }
      if (this.appStatus && Number(this.appStatus.appStage) > 2) {
        return hil_done
      }
      return hil_wait
    },
    img4() {
      if (this.appStatus && Number(this.appStatus.appStage) === 3) {
        return car_work
      }
      if (this.appStatus && Number(this.appStatus.appStage) > 3) {
        return car_done
      }
      return car_wait
    },
    img5() {
      if (this.appStatus && Number(this.appStatus.appStage) === 4) {
        return release_done
      }
      return release_wait
    },
    buttonBack() {
      if (this.appStatus && (this.appStatus.stageStatus > 10 && this.appStatus.stageStatus < 20)) {
        return '返回开发'
      }
      return ''
    },
    buttonName() {
      if (this.appStatus && (this.appStatus.stageStatus === 0 || this.appStatus.stageStatus === 1)) {
        return '提交SIL测试'
      }
      if (this.appStatus && this.appStatus.stageStatus === 13) {
        return '提交HIL测试'
      }
      if (this.appStatus && this.appStatus.stageStatus === 22) {
        return '提交车辆测试'
      }
      if (this.appStatus && (this.appStatus.stageStatus === 10 || this.appStatus.stageStatus === 20 || this.appStatus.stageStatus === 30)) {
        return '取消'
      }
      if (this.appStatus && (this.appStatus.stageStatus === 11 || this.appStatus.stageStatus === 21 || this.appStatus.stageStatus === 31)) {
        return false
      }
      return ''
    },
    clickType() {
      // 0:重新开发 1：提交测试 2：取消排队
      if (this.appStatus && (this.appStatus.stageStatus === 0 || this.appStatus.stageStatus === 1 || this.appStatus.stageStatus === 13 || this.appStatus.stageStatus === 22)) {
        return 1
      }
      if (this.appStatus && (this.appStatus.stageStatus === 10 || this.appStatus.stageStatus === 20 || this.appStatus.stageStatus === 30)) {
        return 2
      }
      if (this.appStatus && (this.appStatus.stageStatus === 0)) {
        return 1
      }
      return 0
    },
    clickBackType() {
      return 0
    }
  },
  watch: {
  },
  destroyed() {
    clearInterval(this.results)
  },
  async created() {
    const that = this
    this.results = await setInterval(() => {
      that.iShowTadSim()
    }, 1000)
    await this.getModuleList()
    const userInfo = JSON.parse(localStorage.getItem('usersCurrentInfo'))
    await this.getSceneSetTree()
    await this.getIndicatorGroupList()
    await this.getLabel()
    this.usersCurrentInfo = userInfo
    console.log(this.appId)
    if (this.appId !== '' && this.appId !== null && this.appId !== undefined) {
      this.form.id = this.appId
      this.getDetails()
    }
    else {
      this.selectCountApp()
    }
  },
  methods: {
    async iShowTadSim() {
      const userInfo = JSON.parse(localStorage.getItem('usersCurrentInfo'))
      if (userInfo.source === '1') {
        const res = await isShowTadSim({ phone: userInfo.phone })
        if (res.code === 0) {
          if (res.data) {
            this.isShowTadSim = true
            this.excess = '1'
            this.$forceUpdate()
          }
          else {
            this.excess = '2'
            this.isShowTadSim = false
            this.$forceUpdate()
          }
        }
        else {
          this.excess = '2'
        }
      }
      this.excess = '2'
    },
    async getLabel() {
      const data = {
        status: 1,
        tagGroupId: '1040925626048364544',
        pageSize: 1000
      }
      const res = await getLabel(data)
      if (res.code === 0) {
        this.options = res.data.dataList
      }
    },
    async catalogueUpdate() {
      const catalogueProperties = this.catalogueProperties
      const res = await addorupdata({
        appType: catalogueProperties.appType,
        appName: this.form.appName,
        catalogueId: this.catalogueId,
        id: catalogueProperties.id,
        appDesc: catalogueProperties.newDescribes,
        logoKey: catalogueProperties.newLogoKey,
        logoUrl: catalogueProperties.newLogoUrl
      }, '2')
      if (res.code === 0) {
        this.$message({
          message: '修改成功！',
          type: 'success'
        })
        this.form.appDesc = res.data.appDesc
        this.form.logoKey = res.data.logoKey
        this.form.logoUrl = res.data.logoUrl
        this.form.appType = res.data.appType
        this.cancelCatalogueUpdate()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    logoUrlBeforeUpload(file) {
      this.fileUrlName = file.name
      console.log(file)
      if (file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg') {
        if (file.size < 500 * 1024) {
          this.logFileList = []
          this.$message.success('正在上传')
          return true
        }
        else {
          this.$message.error('图片大小不能超过500kb')
          return false
        }
      }
      this.$message.error('文件格式有误')
      return false
    },
    async logoUrlCutomUpload(data) {
      console.log(data)
      const { file } = data
      const res = await getUploadKey(0)
      const cosKey = res.data
      console.log(cosKey)
      const cosKlg = new COS({
        getAuthorization: (options, callback) => {
          callback({
            TmpSecretId: cosKey.secretId,
            TmpSecretKey: cosKey.secretKey,
            XCosSecurityToken: cosKey.token,
            ExpiredTime: cosKey.expireTime
          })
        }
      })
      const key = 'web/img/' + new Date().getTime() + '-' + file.name
      cosKlg.putObject({
        Bucket: cosKey.bucket, // 指定桶参数coskey参
        Region: cosKey.region,
        Key: key, // this.sourcePath
        ContentType: 'application/octet-stream',
        StorageClass: 'STANDARD',
        Body: file,
        onProgress: function(progressData) {
          console.log(JSON.stringify(progressData))
        }
      }, (err, data) => {
        this.$message({
          message: '上传成功！',
          type: 'success'
        })
        this.catalogueProperties.newLogoKey = key
        this.catalogueProperties.newLogoUrl = 'http://' + data.Location
        this.logFileList = [{ name: file.name, url: 'http://' + data.Location }]
        console.log(err || data)
      })
    },
    handleRemove(file) {
      this.catalogueProperties.newLogoKey = ''
      this.catalogueProperties.newLogoUrl = ''
      this.logFileList = []
      console.log(file)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.uploadDialogVisible = true
    },
    cancelCatalogueUpdate() {
      this.logFileList = []
      this.centerDialogVisible = false
    },
    async selectCountApp() {
      const res = await selectCountApp({})
      if (res.code === 0) {
        this.form.appName = '您的第' + res.data + '个应用'
        this.moduleDataList.push({
          id: '000000',
          name: this.form.appName,
          personal: false
        })
        this.$forceUpdate()
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async getDetails() {
      await this.getModuleList()
      this.moduleDataValue = []
      const res = await getDetails({ id: this.form.id })
      if (res.code === 0) {
        this.form = res.data
        if (res.data.sceneSetid !== '' && res.data.sceneSetid !== null) {
          this.getSceneList(res.data.sceneSetid)
        }
        if (res.data.stageStatus !== 0 && res.data.stageStatus !== 1) {
          this.isDisabled = true
        }
        else {
          this.isDisabled = false
        }
        if (res.data.moduleIds !== '') {
          this.moduleDataValue = res.data.moduleIds.split(',').map(Number)
        }
        this.sceneSetTreeValue = JSON.parse(res.data.sceneIds)
        console.log('scene data:', this.sceneSetTreeValue)
        this.fileName = res.data.moduleKey
        this.fileUrlName = res.data.moduleKey
        this.fileList = [{ name: res.data.moduleFile, url: 'http://' + res.data.moduleFile }]
        if (!res.data.moduleId) {
          this.moduleDataList.push({
            id: '000000',
            name: res.data.appName,
            personal: false
          })
        }
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    consoleData() {
      if (this.form.appName === '') {
        this.$message.error('请填写应用名字')
        return
      }
      this.nameFlag = !this.nameFlag
      this.addorupdataApp('1')
    },
    save() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.addorupdataApp('3')
        }
        else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async Submit() {
      if (this.usersCurrentInfo.email && this.usersCurrentInfo.email.indexOf('@uaes') > 0) {
        if (!this.form.appDesc || !this.form.logoUrl) {
          this.catalogueProperties.appType = this.form.appType
          this.catalogueProperties.id = this.form.id
          this.catalogueProperties.newDescribes = this.form.appDesc
          if (this.form.logoUrl !== '' && this.form.logoUrl !== null && this.form.logoUrl !== undefined) {
            this.catalogueProperties.newLogoKey = this.form.logoKey
            this.catalogueProperties.newLogoUrl = this.form.logoUrl
            this.logFileList = [{ name: this.form.logoUrl, url: this.form.logoUrl }]
          }
          this.publishingSettings = true
        }
        else {
          this.sendCodeFun()
          this.scenesCodePublishDialogVisible = true
        }
      }
      else {
        // 联电用户以外
        if (this.usersCurrentInfo.email === null || this.usersCurrentInfo.phone === null) {
          this.scenesPublishDialogVisible = true
        }
        else {
          if (!this.form.appDesc || !this.form.logoUrl) {
            this.catalogueProperties.appType = this.form.appType
            this.catalogueProperties.id = this.form.id
            this.catalogueProperties.newDescribes = this.form.appDesc
            if (this.form.logoUrl !== '' && this.form.logoUrl !== null && this.form.logoUrl !== undefined) {
              this.catalogueProperties.newLogoKey = this.form.logoKey
              this.catalogueProperties.newLogoUrl = this.form.logoUrl
              this.logFileList = [{ name: this.form.logoUrl, url: this.form.logoUrl }]
            }
            this.publishingSettings = true
          }
          else {
            this.sendCodeFun()
            this.scenesCodePublishDialogVisible = true
          }
        }
      }
    },
    async addorupdataApp(type) {
      const form = this.form
      if (form.appStage !== 0) {
        this.$message({
          message: '当前任务未处于开发中,请先取消任务在进行保存操作。',
          type: 'warning'
        })
      }
      else {
        const res = await addorupdata(form, type)
        if (res.code === 0) {
          this.$message({
            message: '保存成功！',
            type: 'success'
          })
          this.form.moduleId = res.data.moduleId
          this.form.moduleConfigId = res.data.moduleConfigId
          this.form.id = res.data.id
          this.form.appStage = res.data.appStage
          window.history.replaceState({ id: 1, name: 'major' }, 'USP开发者平台-车载应用开发', '/major/editor?id=' + res.data.id)
          // this.form = res.data
        }
        else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      }
    },
    // 查询场景集列表
    async getSceneSetList() {
      const res = await getSceneSetList()
      if (res.code === 0) {
        this.sceneSetList = res.data.list
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async getAppTestInfo() {
      const data = {
        id: this.form.id,
        moduleConfigId: this.form.moduleConfigId
      }
      const res = await getAppTestInfo(data)
      console.log(res.data)
      if (res.code === 0) {
        this.appStatus = res.data.app
        this.appStatusInfo = res.data.appInfo
        if (res.data.app.stageStatus !== 0 && res.data.app.stageStatus !== 1) {
          this.isDisabled = true
        }
        else {
          this.isDisabled = false
        }
        this.$nextTick(() => {
          this.drawer = true
        })
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    // 查询场景列表
    async getSceneList(e) {
      this.form.sceneSetid = e
      const res = await getSceneList({ sceneSetid: e })
      if (res.code === 0) {
        this.sceneList = res.data.list
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    getSceneId(e) {
      this.form.sceneId = e
    },
    beforeUpload(file) {
      const flag = true // 根据MIME判断文件合法性行不通，先去掉这个逻辑
      this.addResource = file
      this.fileName = file.name
      console.log(1, this.fileName, this.addResource)
      this.$rum.report({
        msg: `[算法包文件信息]文件名: ${this.fileName}; MIME: ${this.addResource.type}`
      })
      if (flag || ['application/x-zip-compressed', 'application/x-gzip', 'application/tag', 'application/tar.gz', 'application/zip', ...(window.JSCONFIG.algPkgType || [])].includes(this.addResource.type)) {
        this.fileList = []
        this.$message.success('正在上传')
        this.showProgress = true
        return true
      }
      this.$message.error('文件格式有误')
      return false
    },
    async cutomUpload(data) {
      const that = this
      console.log(data)
      const { file } = data
      const res = await getUploadKey(1)
      const cosKey = res.data
      console.log(cosKey)
      const cosKlg = new COS({
        getAuthorization: (options, callback) => {
          callback({
            TmpSecretId: cosKey.secretId,
            TmpSecretKey: cosKey.secretKey,
            XCosSecurityToken: cosKey.token,
            ExpiredTime: cosKey.expireTime
          })
        }
      })
      // const key = 'uspApp/' + this.userInfo.id + '/' + new Date().getTime() + '-' + file.name
      const key = 'uspApp/' + new Date().getTime() + '-' + file.name
      cosKlg.putObject({
        Bucket: cosKey.bucket, // 指定桶参数coskey参
        Region: cosKey.region,
        Key: key, // this.sourcePath
        ContentType: 'application/octet-stream',
        StorageClass: 'STANDARD',
        Body: file,
        onProgress: function(progressData) {
          const res = JSON.parse(JSON.stringify(progressData))
          that.percentage = Math.trunc(res.percent * 100)
          console.log(that.percentage)
        }
      }, (err, data) => {
        this.$message({
          message: '上传成功！',
          type: 'success'
        })
        this.showProgress = false
        this.form.moduleKey = key
        this.form.moduleFile = data.Location
        this.$refs.moduleFile.clearValidate()
        console.log(err || data)
      })
    },
    uploadDownload() {
      window.location = `/capi/web-service/uaes/commons/download?objectKey=${this.form.moduleKey}`
    },
    handlePreview(file) {
      console.log(file)
    },
    open() {
      this.catalogueProperties.appType = this.form.appType
      this.catalogueProperties.id = this.form.id
      this.catalogueProperties.newDescribes = this.form.appDesc
      if (this.form.logoUrl !== '' && this.form.logoUrl !== null && this.form.logoUrl !== undefined) {
        this.catalogueProperties.newLogoKey = this.form.logoKey
        this.catalogueProperties.newLogoUrl = this.form.logoUrl
        this.logFileList = [{ name: this.form.logoUrl, url: this.form.logoUrl }]
      }
      // setTimeout(() => {
      this.centerDialogVisible = true
      // }, 500)
    },
    openWork() {
      if (this.form.id && this.form.moduleConfigId) {
        if (this.form.stageStatus !== 0 && this.form.stageStatus !== 1) {
          this.isDisabled = true
        }
        this.isDrawer = false
        this.getAppTestInfo()
      }
      else {
        this.$message({
          message: '请先保存数据！',
          type: 'error'
        })
      }
    },
    leave() {
      this.$confirm('退出将不会保存未保存的数据', '警告', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.$router.go(-1)
        this.$message({
          type: 'success',
          message: '退出成功'
        })
      }).catch(() => {
      })
    },
    async clickBackButton() {
      const data = {
        id: this.form.id,
        moduleConfigId: this.form.moduleConfigId,
        appStage: this.appStatus.appStage
      }
      if (this.clickBackType === 0) {
        const res = await backAppTest(data)
        if (res.code === 0) {
          this.isDisabled = true
          this.$message({
            type: 'success',
            message: '返回开发成功'
          })
          this.getDetails()
        }
        else {
          this.$message({
            type: 'error',
            message: `返回开发失败,${res.msg}`
          })
        }
        this.getDetails()
        this.drawer = false
      }
    },
    async clickButton() {
      const that = this
      const data = {
        id: this.form.id,
        moduleConfigId: this.form.moduleConfigId,
        appStage: this.appStatus.appStage,
        forceCreate: this.form.forceCreate
      }
      if (this.clickType === 0) {
        const res = await backAppTest(data)
        if (res.code === 0) {
          this.isDisabled = true
          this.$message({
            type: 'success',
            message: '重新开发成功'
          })
          this.getDetails()
        }
        else {
          this.$message({
            type: 'error',
            message: `重新开发失败,${res.msg}`
          })
        }
        this.getDetails()
        this.drawer = false
      }
      else if (this.clickType === 1) {
        console.log('点击事件')
        if (that.isDrawer) {
          that.getDetails()
          that.drawer = false
          return null
        }
        that.isDrawer = true
        const res = await setAppTestInfo(data)
        if (res.code === 0) {
          that.$message({
            type: 'success',
            message: '提交成功'
          })
          that.getDetails()
          that.drawer = false
        }
        else if (res.code === 80 || res.code === 100) {
          console.log('123')
          let msg = '数据存储空间不足，可能导致该任务无法完整回放。您也可在系统配置回放数据管理中清理历史回放数据，释放足够空间后再次提交。'
          if (res.code === 100) {
            msg = '注意:数据存储空间不足，该任务将无法回放。您也可在系统配置回放数据管理中清理历史回放数据，释放足够空间后再次提交'
          }
          this.$confirm(msg, '确认信息', {
            confirmButtonText: '继续提交',
            cancelButtonText: '前往清理',
            type: 'warning',
            center: true,
            confirmButtonClass: 'confirmButtonClass',
            cancelButtonClass: 'cancelButtonClass',
            closeOnClickModal: false,
            distinguishCancelAndClose: true
          })
            .then(() => {
              that.form.forceCreate = true
              that.isDrawer = false
              that.clickButton()
            })
            .catch(action => {
              console.log(action)
              if (action === 'cancel') {
                location.href = `${that.host}/USPSim/user-center`
              }
            })
        }
        else {
          this.getDetails()
          this.drawer = false
          this.$message({
            type: 'error',
            message: `提交失败,${res.message || res.msg}`
          })
        }
      }
      else if (this.clickType === 2) {
        const res = await cancelAppTest({
          id: this.form.id,
          moduleConfigId: this.form.moduleConfigId,
          appStage: this.appStatus.appStage,
          jobId: this.appStatus.jobId
        })
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '取消排队成功'
          })
          this.getDetails()
        }
        else {
          this.$message({
            type: 'error',
            message: `取消排队失败,${res.msg}`
          })
        }
        this.getDetails()
        this.drawer = false
      }
      else {
        this.$message({
          type: 'error',
          message: `操作错误`
        })
        this.getDetails()
        this.drawer = false
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个图片，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    // 查询场景集树
    async getSceneSetTree() {
      const res = await getSceneSetTree()
      if (res.code === 0) {
        // this.sceneSetTree = res.data.list
        this.sceneSetTree = res.data.list.map(sceneSet => {
          sceneSet.scenes = sceneSet.scenes.map(scene => {
            scene.label = scene.desc ? `${scene.desc}(${scene.name})` : scene.name
            return scene
          })
          sceneSet.label = sceneSet.name
          return sceneSet
        })
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    handleChange(value) {
      // console.log('子页面传值')
      // console.log(value)
      // this.moduleDataValue = value
      this.form.moduleIds = value.toString()
    },
    // 查询算法列表
    async getModuleList() {
      const res = await getModuleList()
      if (res.code === 0) {
        this.moduleDataList = res.data.list
        this.$forceUpdate()
        console.log(this.moduleDataList)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async getIndicatorGroupList() {
      const res = await getIndicatorGroupList()
      if (res.code === 0) {
        this.indicatorGroupList = res.data.list
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    // 编辑算法
    updateModules(id) {
      window.open(`${this.host}/USPSim/modules/${id}/update`)
    },
    // 管理算法
    governModules() {
      console.log(this.host)
      window.open(`${this.host}/USPSim/modules`)
    },
    // 刷新算法
    async refreshModules() {
      await this.getModuleList()
      let arr = this.moduleDataList
      const list = this.moduleDataValue
      for (const data of list) {
        arr = arr.filter(function(item) {
          return item.id !== data
        })
      }
      this.moduleDataList = arr
      if (!this.form.moduleId) {
        this.moduleDataList.push({
          id: '000000',
          name: this.form.appName,
          personal: false
        })
        this.$forceUpdate()
      }
    },
    // 管理场景集
    governSceneSet() {
      window.open(`${this.host}/USPSim/scenarios-set`)
    },
    // 刷新场景集
    refreshSceneSet() {
      this.getSceneSetTree()
    },
    // 管理场景集
    governIndicatorGroup() {
      window.open(`${this.host}/USPSim/kpi-group`)
    },
    // 刷新场景集
    refreshIndicatorGroup() {
      this.getIndicatorGroupList()
    },
    sceneSetTreeChange(value) {
      this.sceneSetTreeValue = value
      this.form.sceneIds = JSON.stringify(value)
      console.log(value)
      console.log(JSON.stringify(value))
    },
    getString(objarr) {
      var arr = objarr
      var typeNO = arr.length
      var tree = '['
      for (var i = 0; i < typeNO; i++) {
        tree += '['
        tree += "'" + arr[i][0] + "',"
        tree += "'" + arr[i][1] + "'"
        tree += ']'
        if (i < typeNO - 1) {
          tree += ','
        }
      }
      tree += ']'
      return tree
    },
    async getIndicatorGroupDetail() {
      const id = this.form.indicatorGroupId
      console.log(id)
      if (id === '' || id === null) {
        this.$message({
          message: '请选择指标组',
          type: 'error'
        })
        return false
      }
      const res = await getIndicatorGroupDetail(id)
      if (res.code === 0) {
        this.indicatorGroupDetailVisible = true
        this.indicatorsList = res.data.indicators
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async sendCodeFun() {
      const user = JSON.parse(localStorage.getItem('usersCurrentInfo'))
      const data = { 'to': user.email, 'appName': this.form.appName, 'type': '1' }
      const res = await sendCodeByEmail(data)
      if (res.code === 0) {
        this.$message({
          message: '发送成功！',
          type: 'success'
        })
      }
      else {
        console.log(res.msg)
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    async releaseApp() {
      const data = {
        id: this.form.id,
        appStage: '4',
        stageStatus: '40'
      }
      if (this.releaseAgain) {
        const res = await releaseAppAgain(data)
        if (res.code === 0) {
          this.$message({
            message: '提交成功！',
            type: 'success'
          })
          this.releaseAgain = false
        }
        else {
          console.log(res.msg)
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      }
      else {
        const res = await releaseApp(data)
        if (res.code === 0) {
          this.$message({
            message: '提交成功！',
            type: 'success'
          })
        }
        else {
          console.log(res.msg)
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      }
      this.getDetails()
      this.drawer = false
    },
    async secnesPublishCodeClick() {
      if (!this.scenesPublishCode) {
        this.$message({
          message: '请输入动态验证码',
          type: 'warning'
        })
        return false
      }
      var code = this.scenesPublishCode
      const data = { 'code': code }
      const res = await verifyCodeByEmail(data)
      if (res.code === 0) {
        this.releaseApp()
        this.scenesPublishCode = ''
        this.scenesCodePublishDialogVisible = false
      }
      else {
        console.log(res.msg)
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    // 重新开发
    async backDevelop() {
      const data = { 'id': this.form.id, 'stageStatus': this.appStatus.stageStatus }
      const res = await backDevelopTadsim(data)
      if (res.code === 0) {
        console.log(res.data)
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
      this.getDetails()
      this.drawer = false
    },
    showRefuseMessage(message) {
      this.showRefuseMessageVisible = true
      this.noPassReasonForm.noPassReason = message
    },
    scenesCodePublishDialogClose(done) {
      this.scenesPublishCode = ''
      done()
    },
    accountViewClick() {
      this.$router.push('/article/account')
    },
    cancelCatalogueSettingUpdate(done) {
      this.logFileList = []
      done()
    },
    publishsettingUpdate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateSettings()
        }
        else {
          return false
        }
      })
    },
    async updateSettings() {
      const catalogueProperties = this.catalogueProperties
      const res = await addorupdata({
        appType: catalogueProperties.appType,
        appName: this.form.appName,
        catalogueId: this.catalogueId,
        id: catalogueProperties.id,
        appDesc: catalogueProperties.newDescribes,
        logoKey: catalogueProperties.newLogoKey,
        logoUrl: catalogueProperties.newLogoUrl
      }, '2')
      if (res.code === 0) {
        this.$message({
          message: '修改成功！',
          type: 'success'
        })
        this.form.appDesc = res.data.appDesc
        this.form.logoKey = res.data.logoKey
        this.form.logoUrl = res.data.logoUrl
        this.publishingSettings = false
        this.sendCodeFun()
        this.scenesCodePublishDialogVisible = true
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }
    },
    reSubmit() {
      this.releaseAgain = true
      this.Submit()
    }
  }
}
</script>

<style scoped>
/deep/.el-radio__input.is-checked+.el-radio__label{
  color: #4D78FF;
}
/deep/.el-radio__input.is-checked .el-radio__inner{
  background: white;
}/deep/.el-radio__inner{
  width: 16px;
  height: 16px;
 }
/deep/.el-radio__inner::after{
  width: 10px;
  height: 10px;
  background-color: #4D78FF;
}
.toolbar {
  background-color: #fff;
  display: flex;
  box-sizing: border-box;
  padding: 15px 0;
  width: 100%;
  border-bottom: 1px solid #DDDDDD;
  /*z-index: 3;*/
  /*position: absolute;*/
  align-items:center;
}
.toolbar .command:nth-of-type(1) {
  margin-left: 24px;
}
.toolbar .command {
  font-size: 24px;
  /*box-sizing: border-box;*/
  width: 27px;
  height: 27px;
  /*margin: 0px 6px;*/
  /*border-radius: 2px;*/
  padding-left: 6px;
  /*display: inline-block;*/
  /*border: 1px solid rgba(2, 2, 2, 0);*/
}
.toolbar .command:hover {
  cursor: pointer;
  /*font-size: 28px;*/
  /*border: 1px solid #e9e9e9;*/
}
.toolbar .disable {
  color: rgba(0, 0, 0, 0.25);
}
.toolbar .separator {
  margin: 4px;
  border-left: 1px solid #e9e9e9;
}

/*/deep/#name{*/
/*  border-radius: 4px !important;*/
/*}*/
/deep/.el-dialog__title{
  font-size: 18px;
  font-weight: bold;
}
/deep/.el-dialog__header{
  padding: 40px 20px 0;
}
/deep/.el-dialog__footer{
  padding: 50px 20px 40px;
}
.onWork_line{
  border:2px solid #4D78FF;
}
.line{
  border:2px solid #DDDDDD;
}
.onInit{
  border: 5px solid #B8C9FF;
}
.onOver{
  border: 5px solid #4D78FF;
}
.onWork{
  border: 5px solid #49A37D;
}
/deep/.el-drawer__container{
  overflow-x: hidden;
}
/deep/ .el-form-item__label{
  line-height: 32px;
}
/deep/ .el-form-item__content{
  line-height: 32px;
}
/*/deep/ .el-form-item{*/
/*  margin-bottom: 9px;*/
/*}*/
/*/deep/ .el-form-item__error{*/
/*  display:none;*/
/*}*/
.cancelButton{
  border-color: #4d78ff;
  width: 96px;
  height: 40px
}
.confirmButton{
  color: #fff;
  background-color: #4d78ff;
  border-color: #4d78ff;
  width: 96px;
  height: 40px
}
.waitStatus{
  background-color: #F5F6F8;
  border: 1px solid #DDDDDD;
  color:#A7A7A7;
  border-radius: 12.5px;
  padding: 4px 6px;
  width: 100px;
  display: inline-block;
}
.status{
  background-color: #EDFFEE;
  border: 1px solid #09D589;
  color:#09D589;
  border-radius: 12.5px;
  padding: 4px 6px;
  width: 100px;
  display: inline-block;
}
::v-deep .el-upload-list__item{
  width:80px;
  height:80px;
}
::v-deep .el-upload--picture-card{
  width:80px;
  height:80px;
  line-height:86px;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-button {
  display: none;
}
::-webkit-scrollbar-thumb {
  background: rgb(220 225 225 / 65%);
  cursor: pointer;
  border-radius: 4px;
}
::v-deep .el-upload-list__item {
  transition: all .4s cubic-bezier(.55,0,.1,1);
}
.icon-tittle{
  color: #4D78FF;
  cursor: pointer;
  font-size: 12px;
}
.refresh-icon{
  margin-left: 15px;
  color: rgb(77, 120, 255);
  font-size: 12px;
  cursor: pointer;
}
::v-deep .el-transfer-panel{
  width: 230px;
  height: 460px
}
::v-deep .el-drawer__body{
  overflow-y: auto;
}
</style>
